import { render } from "./likeNews.vue?vue&type=template&id=6eae0556&scoped=true"
import script from "./likeNews.vue?vue&type=script&lang=js"
export * from "./likeNews.vue?vue&type=script&lang=js"

import "./likeNews.vue?vue&type=style&index=0&id=6eae0556&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eae0556"]])

export default __exports__